import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageStateService {
  private currentPage: number = 1;
  private pageLimit: number = 5; // Default limit

  setCurrentPage(page: number): void {
    this.currentPage = page;
  }

  getCurrentPage(): number {
    return this.currentPage;
  }

  setPageLimit(limit: number): void {
    this.pageLimit = limit;
  }

  getPageLimit(): number {
    return this.pageLimit;
  }

  resetCurrentPage(): void {
    this.currentPage = 1;
    this.pageLimit = 5;
  }
}
